module.exports = __webpack_public_path__ + "img/export6.12056e7e.png";